import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

import { CartProvider } from './contexts/CartContext';   // ⭐ import

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <CartProvider>     {/* ⭐ wrap here */}
      <App />
    </CartProvider>
  </BrowserRouter>
);